import { useCallback, useContext } from 'react';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import {
  booleanFacets,
  type FacetBooleanKeys,
  type FacetListKeys,
  type FacetRangeKeys,
  listFacets,
  rangeFacets,
  type Tag
} from './constants';

type RemoveTagFunction = () => void;

function isBooleanFacet(facetKey: any): facetKey is FacetBooleanKeys {
  return booleanFacets.includes(facetKey);
}

function isListFacet(facetKey: any): facetKey is FacetListKeys {
  return listFacets.includes(facetKey);
}

function isRangeFacet(facetKey: any): facetKey is FacetRangeKeys {
  return rangeFacets.includes(facetKey);
}

export default function useRemoveFilterTag({
  facetKey,
  context
}: Tag): RemoveTagFunction {
  const {
    updateAvailabilityFilter,
    updateBooleanFilter,
    updateListFilter,
    updateMakes,
    updateRangeFilter
  } = useContext(AppliedFiltersContext);

  return useCallback(() => {
    const isAvailability = facetKey === 'earliestDayToDeliveryOrPickup';
    if (isAvailability) {
      updateAvailabilityFilter({});
    }

    if (isBooleanFacet(facetKey)) {
      updateBooleanFilter({
        filterKey: facetKey,
        value: false
      });
    }

    if (isListFacet(facetKey)) {
      updateListFilter({
        filterKey: facetKey,
        value: context.key
      });
    }

    if (isRangeFacet(facetKey)) {
      updateRangeFilter({
        filterKey: facetKey,
        value: {}
      });
    }

    if (facetKey === 'makes') {
      updateMakes({ name: context.key, ...context });
    }
  }, [
    context,
    facetKey,
    updateAvailabilityFilter,
    updateBooleanFilter,
    updateListFilter,
    updateMakes,
    updateRangeFilter
  ]);
}
